export default __webpack_public_path__ + "static/media/shape-finger.f235ee64.svg";